"use client";

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Package } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { useInventoryRoomsForCleaner } from "@/hooks/useInventoryRoomsForCleaner";
import { AddInventoryItemForm } from "./AddInventoryItemForm";

export interface AddInventoryItemSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  propertyId: string;
  /** Called with the newly created item so the parent can e.g. select it in a dropdown. */
  onCreated: (item: { id: string; item_name: string; room_id: string | null; [key: string]: unknown }) => void;
}

export function AddInventoryItemSheet({ open, onOpenChange, propertyId, onCreated }: AddInventoryItemSheetProps) {
  const { tDynamic } = useTranslation();
  const { data: rooms = [] } = useInventoryRoomsForCleaner(propertyId);

  const handleCreated = (item: { id: string; item_name: string; room_id: string | null; [key: string]: unknown }) => {
    onCreated(item);
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-auto max-h-[90vh] rounded-t-xl overflow-y-auto">
        <SheetHeader className="text-left pb-4">
          <SheetTitle className="flex items-center gap-2">
            <Package className="w-5 h-5" />
            {tDynamic("Add new inventory item")}
          </SheetTitle>
        </SheetHeader>
        <AddInventoryItemForm
          propertyId={propertyId}
          rooms={rooms.map((r) => ({ id: r.id, name: r.name }))}
          roomRequired
          onSuccess={handleCreated}
          onCancel={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
